import "./style.css";
import Play from "../../assets/play.svg";
import Stop from "../../assets/stop.svg";
import Next from "../../assets/next.svg";
import Preview from "../../assets/previous.svg";
import Pause from "../../assets/pause.svg";
import { useRef } from "react";

export default function Controls({
  audioRef,
  currentMusic,
  iconBtn,
  setIconBtn,
  handleChangeMusic,
}) {
  const progressRef = useRef(null);
  let intervalActiv = null;

  function playPause() {
    intervalActiv = setInterval(() => {
      if (audioRef.current.paused) {
        clearInterval(intervalActiv);
      }

      const duration = audioRef.current.duration / 60;
      const progressDuration =
        ((audioRef.current.currentTime / 60) * 100) / duration;
      progressRef.current.style.width = `${progressDuration}%`;
    }, 1000);

    if (audioRef.current.paused) {
      audioRef.current.play();
      setIconBtn("pause");
      return;
    }
    audioRef.current.pause();
    setIconBtn("play");
  }

  function stopMusic() {
    setIconBtn("play");
    audioRef.current.pause();
    audioRef.current.currentTime = 0;
  }

  return (
    <div className="container-controls">
      <div className="preview-name">
        <h2>{currentMusic.title}</h2>
        <strong>{currentMusic.artist}</strong>
      </div>

      <div className="container-players">
        <div className="container-buttons">
          <img
            src={Stop}
            alt="btn-controls"
            className="btn-control"
            onClick={() => stopMusic()}
          />
          <img
            src={Preview}
            alt="btn-controls"
            className="btn-control"
            onClick={() => handleChangeMusic("preview")}
          />
          <img
            src={iconBtn === "pause" ? Pause : Play}
            alt="btn-controls"
            className="btn-play-pause"
            onClick={() => playPause()}
          />
          <img
            src={Next}
            alt="btn-controls"
            className="btn-control"
            onClick={() => handleChangeMusic("next")}
          />
        </div>
        <div className="container-time">
          <strong className="start">0</strong>
          <div className="container-line">
            <div className="line"></div>
            <div ref={progressRef} className="line-color"></div>
          </div>
          <strong className="end">3:45</strong>
        </div>
      </div>

      <div className="empaty"></div>
    </div>
  );
}
